module.exports = __webpack_public_path__ + "img/no_data.6993265d.png";